import { z } from 'zod';

// App-managed platform settings (docs/03 /admin/settings). These live in the
// platform_settings table (key 'platform_settings') and are editable by system
// admins at runtime — distinct from env-only deploy config. The email FROM
// address and auth records stay env/DNS-managed; only the display name and
// invite expiry are app-managed here.
export const platformSettingsSchema = z.object({
  senderName: z.string().trim().min(1).max(120),
  inviteExpiryDays: z.coerce.number().int().min(1).max(90),
});
export type PlatformSettings = z.infer<typeof platformSettingsSchema>;

// PATCH accepts a partial — only the fields the admin changed.
export const updatePlatformSettingsSchema = platformSettingsSchema.partial();
export type UpdatePlatformSettingsPayload = z.infer<typeof updatePlatformSettingsSchema>;
